import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BadgeVariant } from '../../ui/badge/badge.component';

@Component({
  selector: 'challenge-detail-drawer',
  templateUrl: './challenge-detail-drawer.component.html',
  styleUrls: ['./challenge-detail-drawer.component.scss']
})
export class ChallengeDetailDrawerComponent {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }

  getStatusVariant(): BadgeVariant {
    const map: Record<string, BadgeVariant> = {
      Active: 'success',
      Closed: 'error',
      Pending: 'warning'
    };
    return map[this.getStatus()] || 'secondary';
  }

  getStatus(): string {
    if (!this.challenge) { return ''; }
    const now = new Date();
    const end = this.challenge.bookingDateRangeEnd
      ? new Date(this.challenge.bookingDateRangeEnd)
      : null;
    const start = this.challenge.bookingDateRangeStart
      ? new Date(this.challenge.bookingDateRangeStart)
      : null;
    if (end && now > end) { return 'Closed'; }
    if (start && now < start) { return 'Pending'; }
    return 'Active';
  }
  hasEarnUpTo(text: string): boolean {
  return !!(text && text.includes('Earn up to'));
}

getParts(text: string): string[] {
  const rest = text ? text.replace('Earn up to', '').trim() : '';
  return rest.split(' ').filter(function(p) { return p !== ''; });
}

isNumber(part: string): boolean {
  return !isNaN(Number(part.replace(/[,$]/g, '')));
}
}
